import { Autocomplete, SxProps, TextField, Theme } from "@mui/material";
import { useContext } from "react";

import { LayoutsConfig, MainContext } from "../../../main/context/MainContextProvider";
import { useClientClusterUsinaFilterContext } from "../../../main/context/ClientClusterUsinaFilterContextProvider";

export type SelectedClusterMenuProps = {
    textFieldSx?: SxProps<Theme>
};

export default function SelectClusterMenu(props: SelectedClusterMenuProps) {
    const { textFieldSx } = props;
    const { selectedCluster, setSelectedCluster, availableClusters } =
        useClientClusterUsinaFilterContext();
    const { isMobile, layout } = useContext(MainContext);

    const clustersIds = availableClusters?.map((cluster) => cluster.id).sort((a, b) => a.localeCompare(b));

    return (
        <Autocomplete
            size="small"
            className="px-2"
            value={selectedCluster?.id ?? null}
            onChange={(_: any, newValue: string | null | undefined) => {
                if (!newValue) {
                    setSelectedCluster(undefined);
                    return;
                }
                setSelectedCluster(availableClusters?.find((clsuter) => clsuter.id === newValue));
            }}
            id="plant-select"
            options={clustersIds ?? []}
            getOptionLabel={(option) =>
                availableClusters?.find((client) => client.id === option)?.name || ""
            }
            sx={{ width: isMobile ? "100%" : 200 }}
            clearOnEscape
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Cluster"
                    sx={{
                        "& .MuiInputBase-input": {
                            color: layout == LayoutsConfig.LayoutTwo ? "#FFF" : undefined,
                        },
                        "& .MuiInputLabel-root": {
                            color: layout == LayoutsConfig.LayoutTwo ? "#8F969E" : undefined,
                        },
                        "& .MuiInputLabel-root.Mui-focused": {
                            color: layout == LayoutsConfig.LayoutTwo ? "#E9E9E9" : undefined,
                        },
                        ...textFieldSx,
                    }}
                />
            )}
        />
    );
}
